const drink = [
    {
        id: 1,
        name: 'Sumos naturais',
        price: '2.000'
    },
    {
        id: 2,
        name: 'Cofé abatanado',
        price: '650'
    },
    {
        id: 3,
        name: 'chá de gengibre',
        price: '1.000'
    },
    {
      id: 4,
      name: 'sangria',
      price: '3.000'
    },
    {
      id: 5,
      name: 'água mineral',
      price: '350'
    }
];

export default drink;